/* eslint-disable react-hooks/exhaustive-deps */
import './style.css';
import React from 'react';
import Footer from '../../Components/Footer';
import AllProducts from '../../Components/allProducts';
import ScrollToTop from '../../Components/scrollup';
import ProductNav from '../../Components/productNav';
import productBand from '../../images/banniere.jpg';

export default function Products() {
  const [path1, setPath1] = React.useState('');
  const [path2, setPath2] = React.useState('');
  const [path3, setPath3] = React.useState('');
  
  React.useEffect(() => {
    let pathName = window.location.pathname;
    let pathe = pathName.replace(/%20/g, ' ');
    let newPath1 = pathe.split('/')[2];
    let newPath2 = pathe.split('/')[3];
    let newPath3 = pathe.split('/')[4];
    setPath1(newPath1);
    setPath2(newPath2);
    setPath3(newPath3);
  }, []);

  return (
    <div className='products' id='produits'>
      <img src={productBand} alt="productBand" height="auto"/>
      <div className='product'>
        <ScrollToTop/>
        <div className='nav'>
          <ProductNav/>
        </div>
        <div className='productContain'>
          {path3 ? (
            <h2 className='pathTitle'>{decodeURIComponent(path3)}</h2>
          ) : path2 ? (
            <h2 className='pathTitle'>{decodeURIComponent(path2)}</h2>
          ) : (
            <h2 className='pathTitle'>{path1}</h2>
          )}
          <AllProducts sousFamille={path3} famille={path2} bigFamille={path1} />
        </div>
      </div>
      <Footer/>
    </div>
  );
}
